module.exports = __webpack_public_path__ + "img/sign-bg.a604e4be.png";